<h3 class="text-secondary mt-3">Vehicle {{ index + 1 }}</h3>

<div class="row">
  <div class="col-6 col-md-4 col-lg-2">
    <div class="mb-3">
      <label class="form-label" for="vehicleYear">
        Year
        <span *ngIf="controlIsRequired('Year')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="vehicleYear"
        placeholder="YYYY"
        min="1900"
        [max]="year"
        type="number"
        [formControl]="getFormControl('Year')"
        aria-label="Vehicle's year"
      />
    </div>
  </div>
  <div class="col-6 col-md-4 col-lg-2">
    <div class="mb-3">
      <label class="form-label" for="vehicleMileage">
        Mileage
        <span *ngIf="controlIsRequired('Mileage')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="vehicleMileage"
        placeholder="Mileage"
        type="number"
        min="0"
        step="1000"
        [formControl]="getFormControl('Mileage')"
        aria-label="Vehicle's mileage"
      />
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="vehicleMake">
        Make
        <span *ngIf="controlIsRequired('Make')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="vehicleMake"
        placeholder="Example: Toyota"
        type="text"
        [formControl]="getFormControl('Make')"
        aria-label="Make of vehicle"
      />
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="vehicleModel">
        Model
        <span *ngIf="controlIsRequired('Model')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="vehicleModel"
        placeholder="Example: Camry"
        type="text"
        [formControl]="getFormControl('Model')"
        aria-label="Model of vehicle"
      />
    </div>
  </div>
</div>
<div *ngIf="!controlIsDisabled('Lienholder')" class="row">
  <div class="col-12 col-md-8 col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="vehicleLienholder">
        Lienholder
        <span *ngIf="controlIsRequired('Lienholder')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="vehicleLienholder"
        placeholder="Payments made to"
        type="text"
        [formControl]="getFormControl('Lienholder')"
        aria-label="Vehicle payments made to"
      />
    </div>
  </div>
</div>
<div class="row">
  <div *ngIf="!controlIsDisabled('Payments')" class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="vehiclePayments">
        Monthly Payments
        <span *ngIf="controlIsRequired('Payments')" class="color-error">*</span>
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="vehiclePayments"
          placeholder="Amount"
          type="number"
          min="0"
          step="100"
          [formControl]="getFormControl('Payments')"
          aria-label="Vehicle monthly payments"
        />
      </div>
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('BalanceOwed')"
    class="col-12 col-md-6 col-lg-4"
  >
    <div class="mb-3">
      <label class="form-label" for="balanceOwed">
        Balance Owed
        <span *ngIf="controlIsRequired('BalanceOwed')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="balanceOwed"
          placeholder="Amount"
          type="number"
          min="0"
          step="1000"
          [formControl]="getFormControl('BalanceOwed')"
          aria-label="Balance owed on vehicle"
        />
      </div>
    </div>
  </div>
</div>
